
namespace Gamification.Gamification {
    export class UtentiProdottiClassificheColumns {
        static columnsKey = 'Gamification.UtentiProdottiClassifiche';
    }
}